import { createContext } from 'react'

import { BoxModalContextValue, BoxPaywallContextValue } from '../../types'

export const BoxLockContext = createContext<BoxModalContextValue | BoxPaywallContextValue>({
  componentType: 'modal',
  initialized: false,
  status: 'closed',
  prevStatus: null,
  oneClickSuccessData: null,
  setOneClickSuccessData: () => {
    console.warn('setOneClickSuccessData not implemented')
  },
  setStatus() {
    console.warn('setStatus not implemented')
  },
  open: false,
  interactive: false,
  setOpen() {
    console.warn('setOpen not implemented')
  },
  prefetch: false,
  enablePrefetch() {
    console.warn('enablePrefetch not implemented')
  },
  enableSuccessScreen: false,
  setEnableSuccessScreen() {
    console.warn('setEnableSuccessScreen not implemented')
  },
  isSuccessModalOpen: false,
  closeSuccessModal() {
    console.warn('closeSuccessModal not implemented')
  },
  elementHandle: null,
  embeddedCheckoutEnabled: false,
  openEmbeddedCheckout() {
    console.warn('openEmbeddedCheckout not implemented')
  },
})
